module.exports = __webpack_public_path__ + "static/media/logo5.d30124a5.png";